const dummyFunction = (): void => {};

export default dummyFunction;
